import { onSharePointLinkDetected } from '../actions/internalActions';
import { addComposeLinkViewState } from 'owa-compose-link';
import { addSharePointLink } from 'owa-link-data';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { orchestrator } from 'satcheljs';

orchestrator(onSharePointLinkDetected, actionMessage => {
    addSharePointLink(
        actionMessage.linkId,
        actionMessage.linkUrl,
        actionMessage.sharingLinkIds,
        actionMessage.response
    );

    if (
        (actionMessage.response &&
            actionMessage.response.ResultCode === AttachmentResultCode.Success) ||
        actionMessage.isPreviouslyBeautified
    ) {
        if (actionMessage.shouldAddComposeLinkViewState) {
            addComposeLinkViewState(actionMessage.linkId);
        }
    }
});
